














import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import FamiliesMixin from "../../mixins/http/FamiliesMixin";
import RequestData from "@/store/types/RequestData";
import { httpStore } from "@/store/typed";

@Component({ components: { VSelect } })
export default class FamilySelect extends Mixins(FamiliesMixin) {
  @Prop()
  readonly selected!: string | null;

  @Prop()
  readonly queryKey?: string;

  @Prop()
  readonly label?: string;

  @Prop({ default: "" })
  readonly inputClass?: string;

  @Prop()
  readonly placeholder?: string;

  @Prop({ default: false })
  readonly preselect: boolean;

  @Prop({ default: false })
  readonly actsAsFilter: boolean;

  @Prop()
  readonly filter: any;

  options: VSelectOption[] = [];

  private value: string | null = this.selected || null;

  mounted() {
    this.loadItems();
  }

  get payload() {
    let data: any = {
      page: {
        size: "all",
      },
    };

    if (this.filter) {
      data.filter = this.filter;
    }

    return data;
  }

  get filterDefault() {
    return { id: "all", text: "All" };
  }

  get loading() {
    return httpStore.status[this.tag]?.loading;
  }

  get tag() {
    return `get_families_tag`;
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);

    if (this.queryKey && this.$route.query[this.queryKey] !== this.value) {
      let query = this.$route.query;
      query[this.queryKey] = this.value;

      this.$router.push({ query });
    }
  }

  onItemsReady() {
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find((o) => o.id === this.selected)?.id;
    }
  }

  async loadItems() {
    if (this.actsAsFilter) {
      this.options.unshift(this.filterDefault);
    }
    const resp = await this.getFamilies(this.payload, this.tag);
    this.options = resp.map((o) => {
      return { id: o.id, text: `${o.code} - ${o.name}` };
    });
    this.onItemsReady();
  }
}
